import { Box, Stack, styled, Typography } from '@mui/material';

export const SubmitterName = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: 13,
  lineHeight: '17.76px',
  color: '#000000',
  marginLeft: 5,
}));

export const StatusBox = styled(Box)(() => ({
  height: 30,
  width: 'fit-content',
  borderRadius: 100,
  padding: '6px 6px',
  display: 'flex',
  alignItems: 'center',
  '& .label': {
    fontWeight: 600,
    fontSize: 13,
    lineHeight: '17.76px',
    color: '#000000',
    paddingRight: 3,
  },
}));

export const AnonymousAvatar = styled('div')(({ theme }) => ({
  height: 28,
  width: 28,
  minWidth: 28,
  borderRadius: 28,
  background: 'rgba(96, 125, 139, 1)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const LastModifiedText = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: 13,
  lineHeight: '17.76px',
  color: '#000000',
}));

export const Dot = styled('span')({
  margin: '0px 6px',
  color: '#757575',
  width: 11,
  height: 11,
  borderRadius: '50%',
  display: 'inline-block',
});

export const TemplateCnt = styled(Stack)(() => ({
  '& .checklistIcon': {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    minWidth: 24,
  },
}));

export const TaskNameLink = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 13,
  lineHeight: '17.76px',
  color: '#4E48FA',
  cursor: 'pointer',
}));
